import React, { useState } from "react";
import { Input, InputGroup, InputGroupText } from "reactstrap";
import PropTypes from "prop-types";
import { Eye, EyeOff } from "react-feather";
import styled from "styled-components";

const Container = styled.div`
  input {
    border-right: none;
    height: 48px;
    border-radius: 13px;
    border-left: 2px solid ${({ theme }) => theme.colors.black100};
    border-top: 2px solid ${({ theme }) => theme.colors.black100};
    border-bottom: 2px solid ${({ theme }) => theme.colors.black100};
    background-color: transparent;

    &:focus {
      box-shadow: none;
      border-color: ${({ theme }) => theme.colors.systemBlue};

      ~ .input-group-text {
        border-right: 2px solid ${({ theme }) => theme.colors.systemBlue};
        border-top: 2px solid ${({ theme }) => theme.colors.systemBlue};
        border-bottom: 2px solid ${({ theme }) => theme.colors.systemBlue};
      }
    }

    .input-group-text {
      border-color: 2px solid ${({ theme }) => theme.colors.black100};
    }
  }
`;

const StyledInputGroupText = styled(InputGroupText)`
  svg {
    color: ${({ theme }) => theme.colors.black700};
  }
`;

const PasswordInput = ({
  type,
  placeholder,
  onChange,
  value,
  name,
  ...rest
}) => {
  const [inputType, setInputType] = useState(type);

  return (
    <Container className="position-relative has-icon-right">
      <InputGroup>
        <Input
          name={name || ""}
          type={inputType}
          onChange={onChange}
          value={value}
          placeholder={placeholder || ""}
          {...rest}
        />

        <StyledInputGroupText>
          {inputType !== "text" ? (
            <EyeOff
              size="20"
              onClick={() => setInputType("text")}
            />
          ) : (
            <Eye
              size="20"
              onClick={() => setInputType("password")}
            />
          )}
        </StyledInputGroupText>
      </InputGroup>
    </Container>
  );
};

export default PasswordInput;

PasswordInput.prototype = {
  name: PropTypes.string,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
};
